export default "__VITE_ASSET__B9LhAGKP__"